<template>
    <div class="tracker-container">
        <div class="tracker">            
            <div class="texts">
                <div class="section" v-for="item in tabItems" :key="item.title">                    
                    <p>{{ item.title }}</p>
                    <div :class="item.active ? 'default-status active' : 'default-status'"></div>
                </div>
            </div>
            <div class="progress-container">
                <div
                    class="progress-bar"
                    :style="{height: 'inherit', background: '#FE7A11', borderRadius: '9px', width: `${getProgressPercent}%`}"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LoMiniTracker",
    props: [ "tabItems", "activeIndex" ],
    computed: {
        getProgressPercent() {
            let percent;
            console.log("activeee", this.activeIndex)
            if (this.activeIndex == 0) {
                percent = 0
            } else if (this.activeIndex == 1) {
                percent = 53
            } else {
                percent = 100
            }
            console.log("percent", percent);
            return percent;
        }
    },
    data() {
        return {
            setActivePoints() {
                let activeStatus = true;
                let itemsArray = this.tabItems
                itemsArray.map(item => {
                    item.active = activeStatus;
                    if (item.path == this.$route.path) activeStatus = false;
                })
                this.tabItems = itemsArray;
            }
        }
    },
    beforeMount() {
        this.setActivePoints();
    },
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1, h2, h3, h4, p {
    margin: 0;
    padding: 0;
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
}

h4 {
  font-weight: 700;
  font-size: 16px;
  color: #FE7A11;
  margin: 13px 0px;
}

.tracker-container {
    margin: 24px 0px;
}

.texts {
    display: flex;
    justify-content: space-between;

    .section {
        text-align: center;
        position: relative;

        p {
            color: #727272;
            font-size: 12px;
            line-height: 16px;
            font-weight: bold;
            margin-bottom: 9px;
        }

        .default-status {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #EFEFEF;
            display: inline-block;
            position: absolute;
            bottom: -9px;
        }

        div.active {
           background: #FE7A11;
        }

        &:first-child {
            text-align: left;
            margin-left: -3px;
        }

        &:last-child {
            text-align: right;
            margin-right: 3px;
        }
    }
}

.progress-container {
    background: #EFEFEF;
    height: 7px;
    border-radius: 9px;

    .progress-status {
        background: #FE7A11;
        /* width: 32.5%; */
        height: inherit;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/pages/onboarding/components/LoMiniTracker.vue